import MyLoginComponents from './MyLogin.vue'

const myLogin = {
  install: function (Vue) {
    Vue.component('MyLogin', MyLoginComponents)
  }
}

export default myLogin



// WEBPACK FOOTER //
// ./src/components/login/index.js